'use client';

import { useEffect } from 'react';

export const ScrollWorkaround = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};
